import { polyfill } from 'es6-promise';
polyfill();
import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import { HTTP as axios } from './utils/axios';
import VueProgressiveImage from 'progressive-image/dist/vue';
import Vue2TouchEvents from 'vue2-touch-events';
import './scss/style.scss';
import App from './App.vue';
import atoms from '../src/components/atoms/';
import sanitizeHTML from 'sanitize-html';
import Case from './pages/Case/Case.vue'
import Page from './pages/Page/Page.vue'
import Blog from './pages/Blog/Blog.vue'
import BlogPost from './pages/Blog/BlogPost.vue';
import BlogCategory from './pages/Blog/BlogCategory.vue';
import BlogAuthor from './pages/Blog/BlogAuthor.vue';
import NotFound from './pages/NotFound/NotFound.vue';
import storeDef from './store';
import Start from './pages/Start/Start.vue';
import Slick from 'vue-slick';
import './utils/cookieconsent';


Vue.prototype.$http = axios;

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueProgressiveImage, {
  removePreview: true
});
Vue.use(Vue2TouchEvents);
Vue.config.debug = true;

Vue.prototype.$sanitize = sanitizeHTML
Vue.prototype.$wpoptions = vuetenberg_wp_options;

Vue.component('slick', Slick);


//Define route for vue app
//ref : http://router.vuejs.org/en/
//TODO - Make router dynamic with base path
const router = new VueRouter({
  mode: 'history',
  routes: [
    {path: '/404', name: 'notfound', component: NotFound},
    {path: '/', name: 'frontpage', component: Start},
    {path: '/blog/', name: 'blog', component: Blog},
    {path: '/blog/:slug/', name: 'blogpost', component: BlogPost },
    {path: '/categories/:slug/', name: 'blogcategory', component: BlogCategory },
    {path: '/author/:name/', name: 'blogauthor', component: BlogAuthor },
    {path: '/case/:slug/', name: 'case', component: Case},
    {path: '/:slug/', name: 'page', component: Page },
    {path: '*', redirect: '/404'},
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({selector: to.hash});
        }, 500);
      });
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return {x: 0, y: 0};
    }
  },

});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

const store = new Vuex.Store(storeDef);

new Vue({
  router,
  store,
  template: '<App/>',
  components: {App}
}).$mount('#app')

Vue.config.devtools = true;
